import React, { FC, useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { PUBLIC_PATH } from 'utils/constants';
import { BFF_STEPS } from 'utils/stepsConstants';
import { GenericProps } from 'types/interfaces';
import { saveItem, deleteItem } from 'utils';
import useSessionKeepalive from 'utils/useSessionKeepalive';
import { clearRumRequestCode, setRumRequestCode } from 'utils/initDatadogRum';
import AppsRoutes from './AppsRoutes';
import DatadogRumViewTracking from '../../hooks/useDatadogRumViewTracking';
import { BncProductFormProps } from '../../types/bao-react-forms.type';

export type AppProps = GenericProps & BncProductFormProps;

const App: FC<AppProps> = (props) => {
  const {
    currentStep,
    meta: { requestCode },
  } = props;

  const activeRequestCode = useMemo(() => {
    if (BFF_STEPS.findIndex((step) => step.ID === currentStep) > -1) {
      saveItem('requestCode', requestCode);
      return requestCode;
    } else {
      deleteItem('requestCode');
      return null;
    }
  }, [currentStep, requestCode]);

  useEffect(() => {
    if (activeRequestCode) {
      setRumRequestCode(activeRequestCode);
    } else {
      clearRumRequestCode();
    }
  }, [activeRequestCode]);

  useSessionKeepalive(activeRequestCode);

  return (
    <BrowserRouter basename={PUBLIC_PATH}>
      <DatadogRumViewTracking />
      <AppsRoutes {...props} />
    </BrowserRouter>
  );
};

export default App;
